import { render, staticRenderFns } from "./CardDataTable.vue?vue&type=template&id=61f84eda"
import script from "./CardDataTable.vue?vue&type=script&lang=js"
export * from "./CardDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports